import { useKernelApi } from 'infrastructure/api';
import INSTANT_FEEDBACK_VALIDATION from './createupdate/InstantFeedbackValidation';

const RESOURCE_URL = '/instant-feedback';

const useInstantFeedbackService = () => {
  const { sendPostRequest } = useKernelApi();

  const create = async (data: any) => {
    const general = data?.feedbackGrades?.GENERAL;

    if (!general?.description?.trim()) {
      throw new Error('Feedback text is required');
    }
    const requestData = {
      ...data,
      feedbackGrades: {
        GENERAL: general,
      },
    };
    const response = await sendPostRequest(`/employees/${requestData.employeeId}${RESOURCE_URL}`, requestData);
    return response.json();
  };

  const getValidationSchema = () => Promise.resolve(INSTANT_FEEDBACK_VALIDATION);

  return {
    getValidationSchema,
    create,
  };
};

export default useInstantFeedbackService;
